<template>
  <v-container class="mb-10">
    <v-row
      justify="center"
    >
      <h1>
        Symmetries of combinatorial structures
      </h1>
    </v-row>
    <v-row>
      <v-card>
        <v-card-item>
          The goal of this master's thesis was working with graphs, their symmetries and partial symmetries.
        </v-card-item>

        <v-card-item>
          Finding all symmetries of a graph is a computationally difficult problem that involves searching for permutations
          of vertices which preserve the structure of the graph - the relationships between vertices. The set of all such permutations
          forms a group called the automorphism group. Finding the automorphism group of a graph is a problem computationally
          equivalent to the graph isomorphism problem, meaning it belongs to the class NP-intermediate.
        </v-card-item>

        <v-card-item>
          However, since almost all graphs are asymmetric, having only trivial symmetries, the knowledge of the automorphism group
          does not provide us any new information about the structure of the graph. For this reason, we examine the partial symmetries,
          partial permutations of vertices that must once again preserve adjacency and non-adjacency.
        </v-card-item>
      </v-card>
    </v-row>

    <v-row
      justify="center"
    >
      <v-col
        cols="6"
      >
        <GalleryComponent :gallery="thesisGallery" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <div class="font-weight-bold">
          Website:
          <a href="https://symmetries.vercel.app/#/" target="_blank">Symmetries of combinatorial structures</a>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="font-weight-bold">
        Libraries and technologies used:
        <v-chip class="mr-2" color="primary">Python</v-chip>
        <v-chip class="mr-2" color="primary">PyPy</v-chip>
        <v-chip class="mr-2" color="primary">NetworkX</v-chip>
        <v-chip class="mr-2" color="primary">GAP</v-chip>
        <v-chip class="mr-2" color="primary">pyvis</v-chip>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="font-weight-bold">
        Keywords:
        <v-chip class="mr-2">graphs</v-chip>
        <v-chip class="mr-2">symmetries</v-chip>
        <v-chip class="mr-2">automorphism groups</v-chip>
        <v-chip class="mr-2">partial automorphisms</v-chip>
        <v-chip class="mr-2">graph isomorphism</v-chip>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GalleryComponent from '@/components/Gallery'

export default {
  name: 'ThesisInfo',
  components: { GalleryComponent },
  data () {
    return {
      thesisGallery: [
        {
          image: 'thesis_images/website_d_class.png',
          caption: 'D-class diagram for induced subgraph with 4 vertices and 2 edges'
        },
        {
          image: 'thesis_images/website_monoid_structure.png',
          caption: 'Structure of the partial automorphism monoid, also serves as a navigation'
        },
        {
          image: 'thesis_images/website_custom_graph.png',
          caption: 'Component for creating custom graphs'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
